import { Props } from 'shared/@types';
import { PrivacyPolicyScreen } from 'shared/screens/privacy-policy';
import { Page } from '@web/components/page';
import { withServerProps } from '@web/library/with-server-props';
import { useTranslation } from 'react-i18next';

export default function PrivacyPolicy(props: Props) {
  const { t } = useTranslation('web');

  return (
    <Page {...props} register={(seo) => seo.setTitle(t('layout.footer.privacy_policy'))}>
      <PrivacyPolicyScreen />
    </Page>
  );
}

export const getServerSideProps = withServerProps();
